"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const skLocaleData = require("i18next-icu/locale-data/sk");
exports.default = skLocaleData;
//# sourceMappingURL=sk.js.map